import { CircularProgress, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useBets } from "../../common/contexts/betContext";
import { useFixtures } from "../../common/contexts/fixturesContext";
import StadiumGrid from "../../common/worldcup/StadiumGrid";
import WorldCupFacts from "../../common/worldcup/WorldCupFacts";
import { Match } from "../../types/Match";
import {
  getDateKeyForOffsetFromToday,
  getMatchLocalDateKey,
} from "../../utils/timeUtils";
import BetModal from "../components/BetModal";
import { mockMatch } from "../MobileBets/MobileBetsBody";
import FixtureBody from "./FixtureBody";
import FixtureGroup from "./FixtureGroup";
import FixtureMenu from "./FixtureMenu";
import FixturePanel from "./FixturePanel";
import MobileKnockout from "../MobileKnockout/MobileKnockout";
import "./FixtureStyles.scss";

export const MobileFixtures = () => {
  const [allFixtures, setAllFixtures] = useState<Match[]>([]);
  const [currentFixtures, setCurrentFixtures] = useState<Match[]>([]);
  const [currentPanel, setCurrentPanel] = useState("Upcoming");
  const [value, setValue] = useState(4); // 4 means today
  const { matches, isLoading } = useFixtures();
  const { bets } = useBets();
  // modalbet stuff
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [currentModalMatch, setCurrentModalMatch] = useState<Match>(mockMatch);
  useEffect(() => {
    if (allFixtures.length > 0) {
      const day = getDateKeyForOffsetFromToday(value - 4);
      setCurrentFixtures(
        allFixtures.filter((match) => getMatchLocalDateKey(match) === day)
      );
    }
  }, [value, allFixtures]);

  useEffect(() => {
    const uniqueById = new Map(matches.map((match) => [match.id, match]));
    setAllFixtures(Array.from(uniqueById.values()));
  }, [matches]);

  return (
    <>
      {isLoading ? (
        <div
          style={{
            width: "100%",
            minHeight: "50vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <div className="mobileFixtures__root">
          <FixturePanel
            setCurrentPanel={setCurrentPanel}
            currentPanel={currentPanel}
          />
          {currentPanel === "Upcoming" && (
            <>
              <FixtureMenu
                dayLabels={createDaysArray()}
                value={value}
                setValue={setValue}
              />
              <FixtureBody
                currentFixtures={currentFixtures}
                bets={bets}
                setCurrentModalMatch={setCurrentModalMatch}
                setIsOpen={setIsModalOpen}
              />
            </>
          )}
          {currentPanel === "Group Stage" && (
            <FixtureGroup
              setCurrentModalMatch={setCurrentModalMatch}
              setIsModalOpen={setIsModalOpen}
            />
          )}
          {currentPanel === "Knockout" && <MobileKnockout />}
          {currentPanel === "Info" && (
            <div className="mobileFixtures__stadiums">
              <Typography
                variant="h5"
                fontWeight={700}
                className="mobileFixtures__infoHeading"
              >
                World Cup 2026
              </Typography>
              <Typography className="mobileFixtures__infoSubtitle">
                The biggest tournament in history — across the USA, Mexico and
                Canada.
              </Typography>

              <WorldCupFacts />

              <Typography
                variant="h5"
                fontWeight={700}
                className="mobileFixtures__infoHeading"
              >
                Host Stadiums
              </Typography>
              <StadiumGrid />
            </div>
          )}
          <BetModal
            isOpen={isModalOpen}
            setIsOpen={setIsModalOpen}
            match={currentModalMatch}
          />
        </div>
      )}
    </>
  );
};

export function createDaysArray() {
  let arrayOfMenuLabels = [];
  for (let i = 4; i > 1; i--) {
    arrayOfMenuLabels.push(moment(Date()).add(-i, "days").format("DD MMMM"));
  }
  arrayOfMenuLabels.push("Yesterday");
  arrayOfMenuLabels.push("Today");
  arrayOfMenuLabels.push("Tomorrow");
  for (let i = 2; i < 15; i++) {
    arrayOfMenuLabels.push(moment(Date()).add(i, "days").format("DD MMMM"));
  }
  return arrayOfMenuLabels;
}

export function isSameDay(date1: Date, date2: Date): boolean {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}
